<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
      require: false,
    },
  },
}
</script>

<template>
  <CCard class="shadow-sm">
    <CCardBody>
      <h6 v-if="title" class="card-title">{{ title }}</h6>
      <slot></slot>
    </CCardBody>
  </CCard>
</template>

<style lang="scss" scoped>
.card-title {
  font-weight: 700;
  line-height: 1.2;
  color: #73818f;
}
</style>
